import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {SubmitFeedbackCommand} from "homey-housing-lottery-app-dto";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private readonly http = inject(HttpClient);

  public submitFeedback(command: SubmitFeedbackCommand) {
    return this.http.post<void>(`${environment.apiUrl}/api/private/feedback`, command);
  }
}
